import {Component, OnInit} from '@angular/core';
import {NgForOf} from "@angular/common";
import {SharedModule} from "../../../shared/shared.module";
import {DataColumn} from "../../../models";
import {Router} from "@angular/router";
import {CandidatService} from "../../../services/candidat.service";
import {MatDialog} from "@angular/material/dialog";
import {CandidateDetailsComponent} from "./candidate-details-dialog/candidate-details.component";
import {AddressMenuComponent} from "../../../shared/components/address-menu/address-menu.component";
import {
  AgencyMoreDetailActionForCandidateComponent
} from "./agency-more-detail-action-for-candidate/agency-more-detail-action-for-candidate.component";
import {SvgIconComponent} from "angular-svg-icon";
import { CandidatComponent } from '../../candidat/candidat.component';
import { AddCandidateDialogComponent } from './add-candidate-dialog/add-candidate-dialog.component';
import { ProAccountStatusCellComponent } from './pro-account-status-cell.component';
// B2 : FilterTagComponent est fourni via SharedModule (exporté, non standalone).

@Component({
  selector: 'app-agency-candidates',
  standalone: true,
  imports: [
    SharedModule,
    SvgIconComponent,
    NgForOf
  ],
  templateUrl: './agency-candidates.component.html',
  styleUrl: './agency-candidates.component.scss'
})
export class AgencyCandidatesComponent implements OnInit {

  size = 10;
  offset = 0;
  totalItems = 0;
  isLoading: boolean = false;
  searchKeyword: string = '';
  customColumns: DataColumn[] = [
    {
      header: 'Nom',
      fieldName: 'firstName',
      dataType: 'string',
      col: 'col',
    },
    {
      header: 'Prénom',
      fieldName: 'lastName',
      dataType: 'string',
      col: 'col',
    },
    {
      header: 'Numéro de téléphone',
      fieldName: 'phone',
      dataType: 'string',
      col: 'col',
    },
    {
      header: 'Adresse e-mail',
      fieldName: 'email',
      dataType: 'string',
      col: 'col',
    },
    {
      header: 'Fonction',
      fieldName: 'function',
      dataType: 'string',
      col: 'col',
    },
    {
      header: 'Statut',
      fieldName: 'proStatusLabel',
      dataType: 'string',
      col: 'col',
    },
    {
      header: 'Compte',
      unClickable: true,
      fieldName: 'accountStatus',
      dataType: 'component',
      component: ProAccountStatusCellComponent,
    },
    {
      header: 'Actions',
      unClickable: true,
      fieldName: '',
      dataType: 'component',
      component: AgencyMoreDetailActionForCandidateComponent,
    },
  ];
  etabList: any[] = [];
  candidateListFiltered: any[];
  totalItemsAfterFilter: number;

  // B2 (client clinique — P3) : chips « Fonction » — mapping statique vers les secteurs :
  // Médecin = 1 (Médecins) ; Infirmier = 2 (Infirmier hors bloc) + 3 (Bloc opératoire) — cf. plan B2.
  fonctionFilters = [
    { secteurIds: [1], name: 'Médecin', selected: false },
    { secteurIds: [2, 3], name: 'Infirmier', selected: false },
  ];
  // B1 (client clinique — P2) : chips « Statut ».
  statutFilters = [
    { value: 'VACATAIRE', name: 'Vacataire', selected: false },
    { value: 'TITULAIRE', name: 'Titulaire', selected: false },
    { value: 'REMPLACANT', name: 'Remplaçant', selected: false },
  ];

  constructor(private api: CandidatService,
              private dialog: MatDialog,
              private router: Router
  ) {
  }

  ngOnInit(): void {
    this.loadCandidates();
  }

  loadCandidates(): void {
    this.isLoading = true;
    const selectedSecteurIds = this.fonctionFilters.filter(f => f.selected).flatMap(f => f.secteurIds);
    const selectedProStatus = this.statutFilters.filter(f => f.selected).map(f => f.value).join(',');
    this.api.getAgencyCandidatesWithPagination(this.offset, this.size, this.searchKeyword, selectedSecteurIds, selectedProStatus).subscribe({
      next: (response: any) => {
        this.candidateListFiltered = response.data.map((e: any) => {
          return {
            id: e.id,
            typePosteId: e.typePosteId,
            typeSecteurId: e.typeSecteurId,
            proStatus: e.proStatus,
            accountStatus: e.accountStatus,
            firstName: e.firstname || '',
            lastName: e.lastname || '',
            phone: e.phone,
            email: e.email,
            function: e.profession,
            // fonction inconnue (profil non complété) : pas de statut par défaut trompeur
            proStatusLabel: e.typeSecteurId ? this.proStatusLabel(e.proStatus) : '—'
          }
        });
        this.totalItems = response.total;
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error loading candidates:', err);
        this.candidateListFiltered = [];
        this.totalItems = 0;
        this.isLoading = false;
      }
    });
  }

  /** B1 : libellé FR du statut pro. */
  proStatusLabel(value: string): string {
    switch (value) {
      case 'VACATAIRE': return 'Vacataire';
      case 'TITULAIRE': return 'Titulaire';
      case 'REMPLACANT': return 'Remplaçant';
      default: return '';
    }
  }

  /** B2 : bascule d'un chip (fonction ou statut) puis rechargement de la liste.
   *  `selected` = état émis par le chip (évite une double inversion avec son état interne). */
  toggleFilter(filter: any, selected: boolean): void {
    filter.selected = selected;
    this.offset = 0; // Reset to first page on filter change
    this.loadCandidates();
  }

  handleRowClick(evt: any) {
    const candidatId = evt.id;
    const typePosteId = evt.typePosteId;
    this.router.navigate([`/agency/details-candidate/${candidatId}/${typePosteId}`])
  }

  pagination($event: any) {
    this.offset = $event.pageIndex ;
    this.loadCandidates();
  }

  searchItem(event: any) {
    this.offset = 0; // Reset to first page on search
    if (event) {
      this.searchKeyword = event.target.value.trim().toLowerCase();
    } else {
      this.searchKeyword = '';
    }
    this.loadCandidates();
  }
  openAddCandidatDialog() {
    this.dialog.open(AddCandidateDialogComponent, {
      width: '700px',
      panelClass: 'custom-dialog-container',
      disableClose: true
    }).afterClosed().subscribe(result => {
      if (result === 'refresh') {
        this.ngOnInit();   
      }
    });
  }

}
